import { FC, useEffect } from "react";
import { Provider, type ProviderProps } from "react-redux";
import { useNavigate } from "react-router";

import { createReduxStore } from "./store";
import { THUNK_CONTEXT } from "./thunkContext";

const store = createReduxStore(THUNK_CONTEXT);

const ReduxProvider: FC<Omit<ProviderProps, "store">> = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    THUNK_CONTEXT.navigate = navigate;
  }, [navigate]);

  return <Provider store={store} {...props} />;
};

export default ReduxProvider;
